import { queryKey } from 'Shared/const/queryKey';
import { useTokenStore } from 'Shared/hooks/useTokenStore';
import type { QueryParam } from 'viewup-lib/common';
import { useSDQuery } from 'viewup-lib/react';

import type { getPostCampaignRes } from '../../api/mapper';
import type { PostingQueryKey } from '../../api/queries';

export const useGetPostCampaigns = (
  params?: QueryParam<
    getPostCampaignRes,
    unknown,
    getPostCampaignRes,
    PostingQueryKey['availableList']['queryKey']
  >,
) => {
  const { accessToken } = useTokenStore();
  const queryResult = useSDQuery<
    getPostCampaignRes,
    unknown,
    getPostCampaignRes,
    PostingQueryKey['availableList']['queryKey']
  >({
    ...params?.options,
    enabled: !!accessToken,
    ...queryKey.posting.availableList,
  });

  return queryResult;
};
